/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Holiday
} from '../../schema'


/**
 * List all holiday
 */
export const listHolidays = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Holiday[]>> => {
    return axios.get(
      `/holidays/`,options
    );
  }


export const getListHolidaysQueryKey = () => [`/holidays/`];

    
export type ListHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof listHolidays>>>
export type ListHolidaysQueryError = AxiosError<unknown>

export const useListHolidays = <TData = Awaited<ReturnType<typeof listHolidays>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHolidaysQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHolidays>>> = ({ signal }) => listHolidays({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listHolidays>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create holiday
 */
export const createHoliday = (
    holiday: Holiday, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Holiday>> => {
    return axios.post(
      `/holidays/`,
      holiday,options
    );
  }



    export type CreateHolidayMutationResult = NonNullable<Awaited<ReturnType<typeof createHoliday>>>
    export type CreateHolidayMutationBody = Holiday
    export type CreateHolidayMutationError = AxiosError<unknown>

    export const useCreateHoliday = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHoliday>>, TError,{data: Holiday}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHoliday>>, {data: Holiday}> = (props) => {
          const {data} = props ?? {};

          return  createHoliday(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createHoliday>>, TError, {data: Holiday}, TContext>(mutationFn, mutationOptions)
    }
    